import { PageHeading, StatCardItem, StatCards } from '../../../../components'
import { useImportacao } from './useImportacao'

/**
 * Cabeçalho das telas de erros e de registros importados: descrição da importação como título,
 * período como apoio e os números do processamento em cards.
 */
export const ImportacaoResumo = () => {
  const { importacao } = useImportacao()

  const periodo = [
    importacao?.inicioFormatado && `Início ${importacao.inicioFormatado}`,
    importacao?.terminoFormatado && `Término ${importacao.terminoFormatado}`,
  ]
    .filter(Boolean)
    .join(' · ')

  const erros = importacao?.registrosErros ?? 0
  const stats: StatCardItem[] = [
    { label: 'Registros encontrados', value: importacao?.totalRegistros },
    { label: 'Registros válidos', value: importacao?.registrosValidos },
    { label: 'Registros importados', value: importacao?.registrosImportados },
    { label: 'Erros', value: importacao?.registrosErros, tone: erros > 0 ? 'danger' : 'default' },
    { label: 'Pacientes cadastrados', value: importacao?.pacientesCadastrados },
  ]

  return (
    <>
      <PageHeading
        title={importacao ? importacao.descricao || 'Importação' : 'Carregando importação…'}
        description={[importacao?.nomeArquivo, periodo].filter(Boolean).join(' · ') || undefined}
      />
      <StatCards items={stats} ariaLabel='Resumo da importação' />
    </>
  )
}
